import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Content from '../../../../layout/Content'
import BusWaitTimeViolationSearchForm from './BusWaitTimeViolationSearchForm'
import { breadcrumbsPropTypes } from '../../../../common/resource/proptypes/CommonPropTypes'
import { tzNormalizeDate } from '../../../../../utils/date'
import Table from '../../../../common/Table'
import { getBusWaitTimeViolations } from '../../../../../actions/itinerary/BusWaitTimeViolation'
import { INT_DATE_FORMAT } from '../../../../../config/locale'
import { BUS_WAIT_TIME_VIOLATION_COLUMNS } from '../../../../../config/columns'
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants'

const BusWaitTimeViolations = ({
  breadcrumbs,
  dispatchGetBusWaitTimeViolations,
  loading,
  data,
}) => {

  const handleSubmit = (formValues) => {
    const { fromDateString, toDateString } = formValues;

    const newFormValues = {
      fromDateString: tzNormalizeDate({ date: fromDateString, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: toDateString, format: INT_DATE_FORMAT }),
    }

    dispatchGetBusWaitTimeViolations(newFormValues)
  }

  const content = (
    <>
      <BusWaitTimeViolationSearchForm
        onSubmit={handleSubmit}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
        loading={loading}
      />
      <Table
        data={data}
        columns={BUS_WAIT_TIME_VIOLATION_COLUMNS}
        loading={loading}
        manual={false}
        filterable
        defaultPageSize={DEFAULT_PAGE_SIZE}
      />
    </>
  )

  return (
    <Content
      title='Tiempo de Permanencia Fallido'
      subtitle='Estos se generan cuando un bus no cumple con el tiempo de permanencia establecido en su programación.'
      content={content}
      breadcrumbs={breadcrumbs}
    />
  )
}

BusWaitTimeViolations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetBusWaitTimeViolations: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    busId: PropTypes.string,
    busLicensePlate: PropTypes.string
  })).isRequired,
}

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tiempo de Permanencia Fallido',
      href: '',
    },
  ],
  loading: ItineraryUnit.BusWaitTimeViolation.getIn(['all', 'loading']),
  data: ItineraryUnit.BusWaitTimeViolation.getIn(['all', 'content', 'content']),
})

const mapDispatchToProps = {
  dispatchGetBusWaitTimeViolations: getBusWaitTimeViolations
}

export default connect(mapStateToProps, mapDispatchToProps)(BusWaitTimeViolations)